import React, { useEffect, useState } from 'react';
import styles from './BackgroundNoise.module.css';

const BackgroundNoise = () => {
  const [noises, setNoises] = useState([]);
  const [largeNoises, setLargeNoises] = useState([]);
  
  useEffect(() => {
    // Генерируем крупные шумы по краям (noise-1.png - noise-5.png)
    const generateLargeNoises = () => {
      const newLargeNoises = [];
      
      // Левая сторона (2-3 элемента)
      const leftCount = Math.floor(Math.random() * 2) + 2; // 2-3 элемента
      for (let i = 0; i < leftCount; i++) {
        const imageNumber = Math.floor(Math.random() * 5) + 1; // числа от 1 до 5
        newLargeNoises.push({
          id: `large-left-${i}`,
          image: `images/noises/noise-${imageNumber}.png`,
          position: {
            top: `${(i * 40) + Math.random() * 20}vh`, // Распределяем по высоте
            left: 0,
          },
          side: 'left-large'
        });
      } 
      
      // Правая сторона (2-3 элемента)
      const rightCount = Math.floor(Math.random() * 2) + 2; // 2-3 элемента
      for (let i = 0; i < rightCount; i++) {
        const imageNumber = Math.floor(Math.random() * 5) + 1; // числа от 1 до 5
        newLargeNoises.push({
          id: `large-right-${i}`,
          image: `images/noises/noise-${imageNumber}.png`,
          position: {
            top: `${(i * 40) + Math.random() * 20}vh`, // Распределяем по высоте
            right: 0,
          },
          side: 'right-large'
        });
      }
      
      setLargeNoises(newLargeNoises);
    };

    // Генерируем обычные шумы (noise-5.png - noise-51.png)
    const generateNoises = () => {
      const newNoises = [];
      
      // Генерируем шумы для левой стороны
      for (let i = 0; i < 15; i++) {
        const imageNumber = Math.floor(Math.random() * 47) + 5; // числа от 5 до 51
        newNoises.push({
          id: `left-${i}`,
          image: `images/noises/noise-${imageNumber}.png`,
          position: {
            top: `${(i * 15) + Math.random() * 10}vh`,
            left: `${Math.random() * 15}vw`,
          },
          side: 'left'
        });
      }
      
      // Генерируем шумы для правой стороны
      for (let i = 0; i < 15; i++) {
        const imageNumber = Math.floor(Math.random() * 47) + 5; // числа от 5 до 51
        newNoises.push({
          id: `right-${i}`,
          image: `images/noises/noise-${imageNumber}.png`,
          position: {
            top: `${(i * 15) + Math.random() * 10}vh`,
            right: `${Math.random() * 15}vw`,
          },
          side: 'right'
        });
      }
      
      setNoises(newNoises);
    };
    
    generateLargeNoises();
    generateNoises();
  }, []);
  
  // Функция для получения классов для большого шума
  const getLargeNoiseClass = (side) => {
    return side === 'left-large' 
      ? `${styles.noiseImageLarge} ${styles.leftLarge}` 
      : `${styles.noiseImageLarge} ${styles.rightLarge}`;
  };
  
  // Функция для получения классов для обычного шума
  const getNoiseClass = (side) => {
    return side === 'left' 
      ? `${styles.noiseImage} ${styles.left}` 
      : `${styles.noiseImage} ${styles.right}`;
  };
  
  return (
    <div className={styles.backgroundNoiseWrapper}>
      <div className={styles.backgroundNoise}>
        {/* Большие шумы по краям */}
        {largeNoises.map(noise => (
          <img 
            key={noise.id}
            className={getLargeNoiseClass(noise.side)}
            src={noise.image}
            alt=""
            style={{
              top: noise.position.top,
              left: noise.side === 'left-large' ? noise.position.left : 'auto',
              right: noise.side === 'right-large' ? noise.position.right : 'auto',
              opacity: 0.2 + Math.random() * 0.3
            }}
          />
        ))}
        
        {/* Обычные шумы */}
        {noises.map(noise => (
          <img 
            key={noise.id}
            className={getNoiseClass(noise.side)}
            src={noise.image}
            alt=""
            style={{
              top: noise.position.top,
              left: noise.side === 'left' ? noise.position.left : 'auto',
              right: noise.side === 'right' ? noise.position.right : 'auto',
              opacity: 0.3 + Math.random() * 0.3
            }}
          />
        ))}
      </div>
      <div className={styles.footerNoiseContainer}>
        <img 
          className={styles.footerNoise} 
          src="images/noises/footer_noise.png" 
          alt=""
        />
      </div>
    </div>
  );
};

export default BackgroundNoise; 